import { render, staticRenderFns } from "./GameWinLose.vue?vue&type=template&id=1d9b8703&scoped=true&"
import script from "./GameWinLose.vue?vue&type=script&lang=js&"
export * from "./GameWinLose.vue?vue&type=script&lang=js&"
import style0 from "./GameWinLose.vue?vue&type=style&index=0&id=1d9b8703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9b8703",
  null
  
)

export default component.exports